import { ProtectedRoute } from "@app/protected-route";
import { OcrSettings } from "@pages/ocr-settings/ocr-settings";
import { isOcrSection, type OcrSection } from "@pages/ocr-settings/types";
import { createFileRoute } from "@tanstack/react-router";

interface SearchParams {
	section: OcrSection;
}

export const Route = createFileRoute("/_layout/settings/ocr/$ocrId/")({
	component: RouteComponent,
	validateSearch: (search: Record<string, unknown>): SearchParams => ({
		section: isOcrSection(search.section) ? search.section : "ocr_fields",
	}),
});

function RouteComponent() {
	return (
		<ProtectedRoute requiredPermissions={["root", "ocr_settings"]}>
			<OcrSettings />
		</ProtectedRoute>
	);
}
